module.exports = "<div class=zl-admin-spinner> <div class=rect1></div> <div class=rect2></div> <div class=rect3></div> <div class=rect4></div> <div class=rect5></div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TmSpinner.vue
 ** module id = 266
 ** module chunks = 0
 **/